"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewerState = useViewerState;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _viewerContext = require("../viewer-context");

function useViewerState() {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewer = _useState2[0],
      setViewer = _useState2[1];

  var ctx = _react["default"].useContext(_viewerContext.ViewerContext);

  if (ctx) {
    return [ctx.viewer, ctx.setViewer];
  }

  return [viewer, setViewer];
}